import React from 'react';
import PropTypes from 'prop-types';
import {Image, withSitecoreContext} from '@sitecore-jss/sitecore-jss-react';
import { isServer } from '@sitecore-jss/sitecore-jss/utils';
import Link from '../../../Link/Link.jsx';
import Button from '../../../Button/Button.jsx';
import Ribbon from '../../../Ribbon/Ribbon.jsx';
import { CardComponent, HoverWrapper, MobileButtonWrapper } from '../CardTypes.styles';
import { useDeviceResize } from '../../../../../hooks';
import { ConditionalComponentWrapper } from '../../../../../helpers/componentHelpers';
import { trademarkFilterHelper } from '../../../../../helpers/trademarkFilterHelper';
import { useTranslation } from 'react-i18next';
import LazyLoadImage from '../../../../LazyImage/LazyImage.jsx';

const FeaturedCard = ({
                      sitecoreContext = {},
                      image = {},
                      promoImage = {},
                      title = '',
                      link = '',
                      itemId = '',
                      type = 'featured',
                      classValue = '',
                    }) => {
const { trademarkReplacements = [] } = sitecoreContext;
const { t } = useTranslation();
const device = useDeviceResize();
  return (
    <CardComponent type={type} className={classValue}>
      <header>
        {!isServer() && <Button type="love" size={device === 'mobile' ? 'small' : 'large'} itemId={itemId} />}
      </header>

      {!isServer() && (
        <ConditionalComponentWrapper
          condition={link}
          wrapper={children => (
            <Link href={link.href} className="button-link">
              {children}
            </Link>
          )}
        >
          <div className="image-container">
            {image?.value.src &&
              <Image
                field={image}
                imageParams={{mw: 800, mh: 800 }}
              />
            }
            {device === 'desktop' && (
              <HoverWrapper>
                {promoImage?.url && (
                  <img loading="lazy" src={promoImage?.url} alt={promoImage?.alt} className="hover-image" />
                )}
                <Ribbon variant="yellow" />
              </HoverWrapper>
            )}
          </div>

          {(device === 'mobile' || device === 'tablet') && (
            <MobileButtonWrapper type={type}>
              <span>{t( 'BushsBeans.Search.Grids.Recipes.MobileLabel', 'view recipe')}</span>
            </MobileButtonWrapper>
          )}

          <footer>
            {title && (
              <h3 dangerouslySetInnerHTML={{ __html: trademarkFilterHelper(typeof title === 'object' ? title.value : title, trademarkReplacements) }} />
            )}
          </footer>
        </ConditionalComponentWrapper>
      )}
    </CardComponent>
  );
};

export default withSitecoreContext()(FeaturedCard);

FeaturedCard.propTypes = {
  image: PropTypes.object,
  itemId: PropTypes.string,
};